import React from 'react'
import { connect } from 'react-redux'
import AuthActions from '../Redux/AuthRedux'
import { Redirect } from 'react-router-dom'

class LoginPage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      redirect: false,
      error: null
    }
  }

  componentDidMount = () => {
    this.props.checkAuth()
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.auth.user && !nextProps.auth.err) {
      this.setState({redirect: true, error: null})
    }
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let newState = {...this.state}
    newState[field] = val
    this.setState(newState)
  }

  _formSubmit = (event) => {
    event.preventDefault()
    const {email, password} = this.state
    const data = {
      email,
      password
    }

    this.props.login(data)
  }

  render () {
    if (this.state.redirect) {
      let redirect = '/'
      if (this.props.auth.user.role === 'admin') {
        redirect = '/destination/manage'
      } else {
        redirect = '/order/list'
      }
      const history = this.props.history.location
      if (history.state && history.state.from && history.state.from.pathname) {
        redirect = history.state.from.pathname
      }
      return <Redirect to={redirect} />
    }

    const {fetching, err} = this.props.auth
    return (
      <div className='auth'>
        <div className='auth-container'>
          <div className='card'>
            <header className='auth-header'>
              <h1 className='auth-title'>Login</h1>
            </header>
            <div className='auth-content'>
              {err &&
                <div className='alert alert-danger'>{err}</div>
              }
              {this.state.error &&
                <div className='alert alert-danger'>{this.state.error}</div>
              }
              <form onSubmit={event => this._formSubmit(event)}>
                <div className='form-group'>
                  <label htmlFor='email'>E-Mail</label>
                  <input
                    type='email'
                    className='form-control underlined'
                    name='email'
                    id='email'
                    placeholder='Your email address'
                    required
                    onChange={(event) => this._inputChange(event, 'email')}
                    disabled={fetching}
                  />
                </div>
                <div className='form-group'>
                  <label htmlFor='password'>Password</label>
                  <input
                    type='password'
                    className='form-control underlined'
                    name='password'
                    id='password'
                    placeholder='Your password'
                    required
                    onChange={(event) => this._inputChange(event, 'password')}
                    disabled={fetching}
                  />
                </div>
                <div className='form-group'>
                  <button type='submit' className='btn btn-block btn-primary' disabled={fetching}>
                    {!fetching ? 'Login' : 'Logging in ...'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  auth: state.auth
})

const dispatchToProps = (dispatch) => ({
  login: (data) => dispatch(AuthActions.authRequest(data)),
  logout: () => dispatch(AuthActions.authLogout()),
  init: () => dispatch(AuthActions.authInit()),
  checkAuth: () => dispatch(AuthActions.authCheckRequest())
})

export default connect(stateToProps, dispatchToProps)(LoginPage)



// WEBPACK FOOTER //
// ./src/Pages/LoginPage.js